export default "__VITE_ASSET__C_$Ujhpj__"